(function () {
  function bindGallery(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
    var total = slides.length;
    if (!total) return;
    var index = 0;

    function go(next) {
      index = ((next % total) + total) % total;
      thumbs.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      slides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (el, i) {
        el.classList.toggle('on', i === index);
        el.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (el) {
      el.addEventListener('click', function () {
        go(Number(el.dataset.index));
      });
    });
    dots.forEach(function (el) {
      el.addEventListener('click', function () {
        go(Number(el.dataset.index));
      });
    });
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
